import ertToolbar from './ertToolbar.component';

const ertToolbarModule = angular.module('app.common.ertToolbar', [])
	.component('ertToolbar', ertToolbar)
	.name;

export default ertToolbarModule;

